var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"border-t border-gray-darker"}),_vm._v(" "),_c(_vm.makers[_vm.type],{tag:"component",attrs:{"spell":_vm.spell},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }